import React from 'react'
import { Container } from 'react-bootstrap'
import Header from './components/Header'
import Footer from './components/Footer'
import { Outlet, useLocation } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

const App = () => {
  const location = useLocation()
  const hideLayout = location.pathname.startsWith('/barcode')

  return (
    <>
      {!hideLayout && <Header />}
      <main className={hideLayout ? '' : 'py-3'}>
        {hideLayout ? (
          <Outlet />
        ) : (
          <Container>
            <Outlet />
          </Container>
        )}
      </main>
      {!hideLayout && <Footer />}
      <ToastContainer />
    </>
  )
}

export default App